import store from '@/store';
import router from '@/router';

export default async (to, from, next) => {
  const me = store.getters['users/getMe'];
  const { id } = to?.params;
  let noCheck = false;

  if (!me?.id) {
    store
      .dispatch('users/me')
      .then((res) => {
        if (res?.id !== id) {
          //* Confirm intent to log out to view user account
          // const answer = confirm(`${this.$t('auth.wrongUserAccessMsg')}`);
          const answer = confirm(
            `You're trying to access a user account you're not logged in to. Would you like to log out of this account?`
          );
          if (answer) {
            noCheck = true;
            store.dispatch('authentication/logout');
            store.dispatch('users/resetState');
            store.dispatch('licenses/resetLicenses');

            // //* remove users preferences from local storage
            // localStorage.removeItem('userPreferences');
            router.push(`${to.path}`).catch(() => {});
            return;
          }

          // next(`/users/${id}`);
          if (res?.id) {
            next(`/users/${res.id}`);
          } else {
            next(`/users/${id}`);
          }
          return;
        }
        next();
      })
      .catch((error) => {
        console.error('error:', error);
      });
    return;
  }

  if (me?.id !== id && !noCheck) {
    // const answer = confirm('Would you like to log out?');
    // if (answer) {
    //   localStorage.removeItem('token');
    //   next(`/users/${id}/bag-management`);
    //   return;
    // }
    // next(`/users/${id}`);
    next(`/`);
    return;
  }

  next();
};
